// src/store/slices/authSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../index'
import { LoginResponse } from '../../types/api/responses'

export interface AuthState {
  accessToken: string
  refreshToken: string
  isAuthenticated: boolean
}

const initialState: AuthState = {
  accessToken: '',
  refreshToken: '',
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<LoginResponse>) => {
      const { access_token: accessToken, refresh_token: refreshToken } = action.payload
      if (accessToken && refreshToken) {
        // Only set if we have both tokens
        state.accessToken = accessToken
        state.refreshToken = refreshToken
        state.isAuthenticated = true
        localStorage.setItem('access_token', accessToken)
        localStorage.setItem('refresh_token', refreshToken)
      }
    },

    restoreAuth: (state) => {
      const accessToken = localStorage.getItem('access_token')
      const refreshToken = localStorage.getItem('refresh_token')

      if (accessToken && refreshToken) {
        state.accessToken = accessToken
        state.refreshToken = refreshToken
        state.isAuthenticated = true
      } else {
        // If either token is missing, clear everything
        state.accessToken = ''
        state.refreshToken = ''
        state.isAuthenticated = false
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('selectedProjectId')
        localStorage.removeItem('user')
      }
    },

    logout: (state) => {
      state.accessToken = ''
      state.refreshToken = ''
      state.isAuthenticated = false
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('selectedProjectId')
      localStorage.removeItem('user')
    },
  },
})

export const { setCredentials, logout, restoreAuth } = authSlice.actions

export default authSlice.reducer

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const refreshTokenSelector = (state: RootState) => state.auth.refreshToken
